import styled from 'styled-components'

import { media, bigLg } from '../../../utils/style-utils'

export const Item = styled.div`
  width: 96%;
  max-width: ${bigLg}px;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  gap: 1rem;

  ${media.xl`
    flex-direction: column;
  `}

  ${media.lg`
    width: 100%;
  `}
`
